import {
  waitForEvent
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/modal-mobile/modal-mobile.ts
var FadvMobileModal = class extends s {
  constructor() {
    super(...arguments);
    this.desktop = "desktop";
    this.mobile = "mobile";
    this.breakpoint = 768;
  }
  get components() {
    const children = [...this.children];
    const desktop = children.find((m) => m.getAttribute("name") === this.desktop);
    const mobile = children.find((m) => m.getAttribute("name") === this.mobile);
    return [desktop, mobile];
  }
  get isMobile() {
    return document.body.clientWidth < this.breakpoint;
  }
  handleOpenChange() {
    if (this.open) {
      const [desktop, mobile] = this.components;
      if (this.isMobile) {
        mobile.show();
      } else {
        desktop.show();
      }
    } else {
      this.components.forEach((m) => m.hide());
    }
  }
  show() {
    this.open = true;
  }
  hide() {
    this.open = false;
  }
  handleResize() {
    if (!this.open)
      return;
    const [desktop, mobile] = this.components;
    const isMobile = this.isMobile;
    let component;
    if (isMobile && !mobile.open) {
      component = desktop;
    } else if (!isMobile && !desktop.open) {
      component = mobile;
    }
    if (component) {
      waitForEvent(component, "sl-after-hide").then(() => this.show());
      component.hide();
    }
  }
  handleHideEvent(event) {
    const target = event.target;
    if (!this.components.includes(target))
      return;
    this.hide();
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleHideEvent = this.handleHideEvent.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.addEventListener("sl-hide", this.handleHideEvent);
    this.resizeObserver = new ResizeObserver(this.handleResize);
    this.resizeObserver.observe(document.body);
  }
  disconnectedCallback() {
    var _a;
    try {
      (_a = this.resizeObserver) == null ? void 0 : _a.unobserve(document.body);
      this.removeEventListener("sl-hide", this.handleHideEvent);
    } catch (e2) {
    }
    super.disconnectedCallback();
  }
  render() {
    return $`<slot></slot>`;
  }
};
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvMobileModal.prototype, "open", 2);
__decorateClass([
  e({ reflect: true })
], FadvMobileModal.prototype, "desktop", 2);
__decorateClass([
  e({ reflect: true })
], FadvMobileModal.prototype, "mobile", 2);
__decorateClass([
  e({ reflect: true })
], FadvMobileModal.prototype, "breakpoint", 2);
__decorateClass([
  watch("open")
], FadvMobileModal.prototype, "handleOpenChange", 1);
FadvMobileModal = __decorateClass([
  n("fadv-mobile-modal")
], FadvMobileModal);

export {
  FadvMobileModal
};
